import React from 'react';
import { Alert, AlertTitle, Link as MuiLink, Typography } from '@mui/material';

const SUPPORT_URL =
  'https://tpnplus.atlassian.net/servicedesk/customer/portal/3';

type ApiErrorAlertProps = {
  show: boolean;
  title?: string;
  message?: string;
  onClose?: () => void;
};

export function ApiErrorAlert({
  show,
  title = 'We could not save your response',
  message = 'Please refresh the page and try again.',
  onClose,
}: ApiErrorAlertProps) {
  if (!show) return null;

  return (
    <Alert severity="error" sx={{ mt: 2 }} onClose={onClose}>
      <AlertTitle>{title}</AlertTitle>

      <Typography>
        {message} If the issue persists,{' '}
        <MuiLink
          href={SUPPORT_URL}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: 'inherit',
            textDecoration: 'underline',
            textDecorationColor: 'currentColor',
            '&:hover': {
              color: 'inherit',
              textDecorationColor: 'currentColor',
            },
          }}
        >
          contact support
        </MuiLink>
        .
      </Typography>
    </Alert>
  );
}